import React from "react";
import PropTypes from "prop-types";

//images
import {GOL_ACRONYM, GOL_TWO_FACTOR_MESSAGE} from "../../../../js/shared/constants";
import { ItemCardImageDefault } from "./ItemCardImageDefault";

export const ItemCardInfoDefault = ({ fidelityProgram }) => {
	const { id, fidelityName, acronym, international } = fidelityProgram;

	const textMultiplus = (
		<p className="item-card-info-default--text">
			Para fazer a emissão de passagens utilizando suas milhas, a MaxMilhas precisará acessar sua
			conta no programa de fidelidade.
			<br />
			<br />
			Por isso, você deve informar o usuário e a senha de acesso que estão
			cadastrados no site da {fidelityName}.<br />
			<br />
			Lembramos que o titular do programa de fidelidade deve ser o mesmo do cadastro da MaxMilhas.
		</p>
	);

	const textFlyingBlue = (
		<p className="item-card-info-default--text">
			Para fazer a emissão de passagens utilizando suas milhas, a MaxMilhas precisará acessar sua
			conta no programa de fidelidade.
			<br />
			<br />
			Por isso, você deve informar o usuário e a senha de acesso que estão
			cadastrados no site da {acronym}.<br />
			<br />
			Lembramos que o titular do programa de fidelidade deve ser o mesmo do cadastro da MaxMilhas.
		</p>
	);

	const textDefault = (
		<p className="item-card-info-default--text">
			Para fazer a emissão de passagens utilizando suas milhas, a MaxMilhas precisará acessar sua
			conta no programa de fidelidade.
			<br />
			<br />
			Por isso, você deve informar o usuário e a senha de acesso que estão cadastrados no site
			da&nbsp;
			{international === "1" ? acronym : fidelityName}.
			<br />
			<br />
			Lembramos que o titular do programa de fidelidade deve ser o mesmo do cadastro da MaxMilhas.
		</p>
	);

	return (
		<div className="item-card-info-default">
			<p className="item-card-info-default--title">Por que precisamos desses dados?</p>
			{id === 3 ? textMultiplus : id === 10 ? textFlyingBlue : textDefault}
			{acronym === GOL_ACRONYM ? <p>{GOL_TWO_FACTOR_MESSAGE}</p> : null}

			<p className="item-card-info-default--title">Seus dados estão seguros</p>
			<p className="item-card-info-default--text">
				Vale sempre lembrar que nossa plataforma é blindada e tem certificação de excelência em
				segurança. Aqui, seus dados estão protegidos.
			</p>
			<ItemCardImageDefault />
		</div>
	);
};

ItemCardInfoDefault.propTypes = {
	fidelityProgram: PropTypes.object
};
